import { watch } from '@vue/reactivity'
import { store } from './component/store.js'
import { nextTick } from './component/nextTick.js'
import { initRouter } from './router'
import { components, componentCleanupMap, observeChanges } from './component/reactive.js'
import { initComponents, reviveContentIn } from './component/init.js'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'

export default {

    $router: null,

    getComponents() {
        return components
    },

    componentCleanupMap() {
        return componentCleanupMap
    },

    initialize() {

        this.$router = initRouter()
        observeChanges()
        initComponents()
        document.dispatchEvent(new Event('arbor:initialized'))

    },

    store(key = null, value = null) {
        return store(key, value)
    },

    router() {

        if (!this.$router) {
            this.$router = initRouter()
        }

        return this.$router

    },

    watch(target, callback, options) {
        return watch(target, callback, options)
    },

    debounce(callable, delay) {
        return debounce(callable, delay)
    },

    throttle(callable, delay) {
        return throttle(callable, delay)
    },

    nextTick(callable) {
        return nextTick(callable)
    },

    reviveContentIn(root, scope) {
        return reviveContentIn(root, scope)
    },

}
